import { ChangeDetectorRef, Component, afterNextRender, inject, signal } from '@angular/core';
import { GoogleMap, MapMarker } from '@angular/google-maps';
import { EnvironmentService } from '@core';

@Component({
    selector: 'app-google-maps',
    standalone: true,
    imports: [GoogleMap, MapMarker],
    templateUrl: './google-maps.component.html',
    styleUrl: './google-maps.component.scss',
})
export class GoogleMapsComponent {
    private cdr = inject(ChangeDetectorRef);
    private env = inject(EnvironmentService);
    protected center = signal<google.maps.LatLngLiteral>({ lat: 14.5995, lng: 120.9842 }); // Manila
    protected zoom = signal(12);
    protected apiLoaded = signal(false);

    protected options: google.maps.MapOptions = {
        mapId: 'DEMO_MAP_ID',
        disableDefaultUI: false,
    };

    constructor() {
        afterNextRender(() => {
            this.loadGoogleMapsApi();
        });
    }

    private loadGoogleMapsApi() {
        const apiKey = this.env.config.googleMapsApiKey;

        if (typeof window !== 'undefined' && window.google && window.google.maps) {
            this.apiLoaded.set(true);
            this.cdr.detectChanges();
            return;
        }

        if (!document.getElementById('google-maps-script')) {
            const script = document.createElement('script');
            script.id = 'google-maps-script';
            script.src = `https://maps.googleapis.com/maps/api/js?key=${apiKey}&libraries=places`;
            script.async = true;
            script.defer = true;
            script.onload = () => {
                this.apiLoaded.set(true);
                this.cdr.detectChanges();
            };
            document.head.appendChild(script);
        } else {
            // Script tag exists but API might not be fully initialized yet
            const checkGoogleInterval = setInterval(() => {
                if (window.google && window.google.maps) {
                    this.apiLoaded.set(true);
                    this.cdr.detectChanges();
                    clearInterval(checkGoogleInterval);
                }
            }, 100);
        }
    }
}
